import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import axios from 'axios'

import Jordskiftekrevd from './Jordskiftekrevd.jsx'
import JordskiftekrevdIcon from '../../../images/Jordskiftekrav.png'
import CollapseIcon from '../../../images/expand copy 3.png'
import ExpandIcon from '../../../images/collapse copy 3.png'

class JordskiftekrevdList extends Component {
    state = {
        jordskifteKrevde: [],
        isLoading: false,
        isOpened: false,
        continuationToken: null        
    }

    getJordskifteKrevde = () => {
        this.setState({isLoading: true})
        axios.get(`${this.props.settings.baseUrl}api/matrikkelenhet/${this.props.matrikkelenhetId}/jordskiftekrevd`, {
            params: {
                token: this.props.token,
                size: 50,
                continuationToken: this.state.continuationToken                
            }
        })
        .then(({data}) => {
            this.setState({
                jordskifteKrevde: [...this.state.jordskifteKrevde, ...data.jordskifteKrevde],
                isLoading: false,
                continuationToken: data.nextContinuationToken
            })
        })
    }

    toggleJordskifteKrevde = () => {
        if (this.props.antall == 0) return

        if (this.state.jordskifteKrevde.length == 0) {
            this.getJordskifteKrevde()
        }

        this.setState({isOpened: !this.state.isOpened})
    }

    render() {
        const { t } = this.props
        var antallJordskifteKrevde = this.state.continuationToken ? `${this.state.jordskifteKrevde.length}/${this.props.antall}` : this.props.antall        
        return (
            <li>
                <div className="section-header" onClick={this.toggleJordskifteKrevde}>
                    { !this.state.isLoading &&
                        <div className="icon-image"><img src={JordskiftekrevdIcon} /></div>
                    }
                    {
                        this.state.isLoading &&
                        <span className="icon"><i className="fa fa-fw fa-spinner fa-spin"></i></span>
                    }
                    <span className="title">{t('jordskiftekrevde')} ({antallJordskifteKrevde})</span>
                    <div className="icon-image right"><img className="collapse" src={this.state.isOpened ? CollapseIcon : ExpandIcon} /></div>
                </div>
                <div className={this.state.isOpened && this.state.jordskifteKrevde.length > 0 ? "" : "collapsed"}>
                    <ul>
                        { this.state.jordskifteKrevde.map((j, index) => {return (<Jordskiftekrevd key={j.jordskifteKrevdId} jordskiftekrevd={j} antall={this.props.antall} isLast={index==this.state.jordskifteKrevde.length-1} />)}) }
                        { this.state.continuationToken &&
                        <li key="HentFlere">
                            <div className="section-header subsection button" onClick={this.getJordskifteKrevde}>
                                <span>{t('hent.jordskiftekrevde')}</span>
                            </div>
                        </li>
                        }
                    </ul>
                </div>
            </li>
        )
    }
}

export default withTranslation('common')(JordskiftekrevdList)